import { ChangeDetectionStrategy, Component, EventEmitter, inject, model, OnDestroy, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BusyButtonDirective } from "rl-common/directives/busy-button.directive";
import { ProgressService } from "rl-common/services/progress.service";
import { TaskConfig, TaskControlGroup } from "rl-common/services/task-config/task-config.models";
import { TaskConfigService } from "rl-common/services/task-config/task-config.service";
import { finalize, Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { WorkflowTaskGroupFormComponent } from "../workflow-task-group-form/workflow-task-group-form.component";

@Component({
	selector: "rl-workflow-task-rules-modal",
	imports: [WorkflowTaskGroupFormComponent, FormsModule, BusyButtonDirective],
	templateUrl: "./workflow-task-rules-modal.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./workflow-task-rules-modal.component.scss",
})
export class WorkflowTaskRulesModalComponent implements OnDestroy {

	charTypeId = model<number>(0);
	processId = model<number>(0);
	task = model<TaskConfig>(null);
	taskGroup = model<TaskControlGroup>(null);

	private readonly _taskConfigService = inject(TaskConfigService);
	private readonly _progressService = inject(ProgressService);

	@Output()
	onComplete = new EventEmitter<[boolean, TaskControlGroup]>();

	private readonly _subs: Subscription[] = [];

	save(taskControlGroup: TaskControlGroup) {
		let save$: Observable<TaskControlGroup>;
		this._progressService.startProgress();
		if (!taskControlGroup.id) {
			save$ = this._taskConfigService.createTaskControlGroupConfig(taskControlGroup).pipe(
				map(result => {
					taskControlGroup.id = result.id;
					return taskControlGroup;
				})
			);
		} else {
			save$ = this._taskConfigService.updateTaskControlGroupConfig(taskControlGroup).pipe(
				map(() => taskControlGroup)
			);
		}
		const sub = save$.pipe(
			finalize(() => this._progressService.endProgress())
		).subscribe(() => {
			this.onComplete.next([true, this.taskGroup()])
		});

		this._subs.push(sub);
	}

	close() {
		this.onComplete.next([false, this.taskGroup()])
	}

	ngOnDestroy(): void {
		this._subs.forEach(sub => sub.unsubscribe());
	}
}
